import { Form } from 'antd';
import React from 'react';

import { LIST_SCHEDULE_ITEM_TYPE } from '../../const';
import { IFieldBase } from '../../interfaces';
import ListItem from '../../outListItem';
import { ItemType } from '../../types';

const FieldType: React.FC<IFieldBase> = ({ disabled }) => {
    return (
        <Form.Item<ItemType> label="Type" name="type">
            <ListItem nameList={LIST_SCHEDULE_ITEM_TYPE} extraFields={['code']} disabled={disabled} readonly />
        </Form.Item>
    );
};

export default React.memo(FieldType);
